<template>
<Layout>
  <div class="section  content is-size-7">
    <p class="is-size-6">Zarządzanie subskrypcją</p>
    <p>Aby dokonać rezygnacji należy wysłać SMS o treści STOP KYF na 80460 (T-Mobile) (koszt: 0 zł).</p>
    <p v-if="state === 'open'">Możesz również skorzystać z naszego narzędzia online.</p>
    <br>

    <p v-if="state === 'open'" class="has-text-centered"><button class="button p-l-lg p-r-lg" @click="cancel">Dezaktywuj</button></p>
    <p v-else-if="state === 'closed'">Subskrypcja została zamknieta.</p>
    <p v-else-if="state === 'already_closed'">Subskrypcja jest juz zamknieta.</p>
    <p v-else-if="state === 'valid'">Subskrypcja jest juz zamknieta.</p>
    <p v-else-if="state === 'undefined'">Subskrypcja nie znaleziono.</p>
    <p v-else-if="state === 'error'">Błąd podczas dezaktywacji subskrypcji.</p>
  </div>
</Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'
import axios from 'axios'

export default {
  name: 'Deactivation',
  data() {
    return {
      saleId: null,
      state: 'open'
    }
  },
  async mounted() {
    if (window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const saleId = window.localStorage.getItem('saleId')
      const res = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ saleId }`)
        .catch(() => { return { data: { state: 'error' } } })
      this.saleId = saleId
    } else this.state = 'undefined'
  },
  methods: {
    async cancel () {
      if (this.saleId === null) return
      const res = await axios.get(`/${ this.$store.getters.apiPrefix }/closeSale/${ this.saleId }`)
        .catch(() => { return { data: { state: 'error' } } })
      this.state = res.data.state
      console.log(`/${ this.$store.getters.apiPrefix }/closeSale/${ this.saleId }`, res.data)
      this.state = res.data.state
    }
  },
  components: {
    Layout
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LangKyf/PL/Deactivation.vue